import { useState, useEffect } from "react";
import { CacheProvider } from '@emotion/react';
import Card2 from "./Card2";
import { addDataPosition, getEndpoint, getMUICache, getUrl, fetchAnchorValue, isCSR, insertAdSlot } from '../../common/utils';
import './Herolayout.css';
import { PAGEBUILDER_URLS } from "../Common/Constant";
import bcrypt from 'bcryptjs-react';
// import { isMobile, isDesktop } from "react-device-detect";

HeroLayout2.version = 1000;

HeroLayout2.lang = 'en';
HeroLayout2.langs = [
    'en'
];
HeroLayout2.setLang = (lang: any) => {
    HeroLayout2.lang = lang;
}

Object.defineProperty(HeroLayout2, 'name', {
    writable: true,
    value: 'HeroLayout2'
});

export function HeroLayout2(props: any) {
    const [cardListData, setCardListData] = useState<any>([]);
    const cache = getMUICache();
    const { title, showAuthorName, showTimeStamp, showViewAll, viewAllUrl, showAdSlot, showViewport, anchorLinksValue } = props;
    const endpoint = getEndpoint(props, "MAIN");
    var { imagesInViewport } = props;
    ////console.log("showViewport: ", showViewport);
    ////console.log("imagesInViewport: ", imagesInViewport);
    
    // const [clientDevice, setClientDevice] = useState({ isDesktop: false, isMobile: false });
    
    // useEffect(() => {
    //     setClientDevice({ isDesktop, isMobile });
    // }, []);

    // clientDevice.isDesktop = isDesktop;
    // clientDevice.isMobile = isMobile;

    // useEffect(() => {
    //     // Add desktop ad scripts to head when component mounts
    //     if (clientDevice.isDesktop && props.data?.attributes?.adConfigurations?.desktop) {
    //         const headScripts = props?.data?.attributes?.adConfigurations.desktop
    //             .map((ad: any) => ad.headScript)
    //             .filter((script: string) => script); // Filter out empty scripts

    //         // Add scripts to head
    //         headScripts.forEach((scriptContent: string) => {
    //             const scriptEl = document.createElement('div');
    //             scriptEl.innerHTML = scriptContent;
                
    //             // Extract and add each script tag
    //             const scripts = scriptEl.getElementsByTagName('script');
    //             Array.from(scripts).forEach(script => {
    //                 const newScript = document.createElement('script');
                    
    //                 // Copy script attributes
    //                 Array.from(script.attributes).forEach(attr => {
    //                     newScript.setAttribute(attr.name, attr.value);
    //                 });
                    
    //                 newScript.innerHTML = script.innerHTML;
    //                 document.head.appendChild(newScript);
    //             });
    //         });
    //     }
        
    //     // Add mobile ad scripts to head when component mounts
    //     if (clientDevice.isMobile && props.data?.attributes?.adConfigurations?.mobile) {
    //         const headScripts = props?.data?.attributes?.adConfigurations.mobile
    //             .map((ad: any) => ad.headScript)
    //             .filter((script: string) => script); // Filter out empty scripts

    //         // Add scripts to head
    //         headScripts.forEach((scriptContent: string) => {
    //             const scriptEl = document.createElement('div');
    //             scriptEl.innerHTML = scriptContent;
                
    //             // Extract and add each script tag
    //             const scripts = scriptEl.getElementsByTagName('script');
    //             Array.from(scripts).forEach(script => {
    //                 const newScript = document.createElement('script');
                    
    //                 // Copy script attributes
    //                 Array.from(script.attributes).forEach(attr => {
    //                     newScript.setAttribute(attr.name, attr.value);
    //                 });
                    
    //                 newScript.innerHTML = script.innerHTML;
    //                 document.head.appendChild(newScript);
    //             });
    //         });
    //     }
    // }, [clientDevice.isDesktop, clientDevice.isMobile, props.data?.attributes?.adConfigurations]);

    useEffect(() => {
        if (typeof window !== 'undefined' && window.gpEditor) {

            window.gpEditor.editor.on('component:selected', (component: any) => {
                if (component && component.attributes && component.attributes.type === "Hero Layout2") {
                    setTimeout(() => {
                        const trait = component.getTraits().find((tr: any) => tr.get('id') === "deviceType");
                        if (trait && trait.el) {
                            // Show trait element if showAdSlot is true, hide otherwise
                            trait.el.style.display = props.showAdSlot ? 'block' : 'none';
                        }
                    }, 200);
                }
            });

            const selected = window.gpEditor.getSelected();
            if (selected) {
                const trait = selected.getTraits().find((tr: any) => tr.get('id') === "deviceType");
                if (trait && trait.el) {
                    // Show trait element if showAdSlot is true, hide otherwise
                    trait.el.style.display = props.showAdSlot ? 'block' : 'none';
                }
            }
        }
    }, [endpoint, props.showAdSlot, props.adSize]);


    // useEffect(() => {
    //     if (clientDevice.isDesktop && props.bodyAdScript) {
    //         const adContainer = document.getElementById("ad-container");
    //         if (adContainer) {
    //             const script = document.createElement("script");
    //             script.async = true;
    //             script.innerHTML = props.bodyAdScript.match(/<script[^>]*>([\s\S]*?)<\/script>/)?.[1] || "";
    //             adContainer.appendChild(script);
    //         }
    //     }
    //     if (clientDevice.isMobile && props.bodyAdMobileScript) {
    //         const adContainer = document.getElementById("ad-container");
    //         if (adContainer) {
    //             const script = document.createElement("script");
    //             script.async = true;
    //             script.innerHTML = props.bodyAdMobileScript.match(/<script[^>]*>([\s\S]*?)<\/script>/)?.[1] || "";
    //             adContainer.appendChild(script);
    //         }
    //     }
    // }, [clientDevice.isDesktop,clientDevice.isMobile, props.bodyAdScript, props.bodyAdMobileScript]);

    useEffect(() => {
        if (!endpoint.isSSR || !endpoint.SSRDataObj) {
            fetchComponentData();
        }
    }, [endpoint, showAdSlot]);

    // if (endpoint.isSSR && endpoint.SSRDataObj
    //     && Object.keys(cardListData).length === 0 && Object.keys(endpoint.SSRDataObj.pg).length != 0) {
    //     setCardListData(endpoint.SSRDataObj.items);
    // }

    if (endpoint.isSSR && endpoint.SSRDataObj
        && Object.keys(cardListData).length === 0 && endpoint.SSRDataObj?.items.length > 0 
        && endpoint.SSRDataObj.pg && Object.keys(endpoint.SSRDataObj.pg).length != 0) {
        setCardListData(endpoint.SSRDataObj.items);
    }


    const fetchComponentData = () => {
        let cardUrl = getUrl(props);
        ////console.log('cardUrl', cardUrl)

        let headerString = '?' + cardUrl.split("?")[1];
        headerString = bcrypt.hashSync(headerString, 6);
        const headers = {'p-nonce': headerString};
        
        fetch(cardUrl, { headers: headers })
            .then(data => data.json())
            .then(val => {
                setCardListData(val.items)
            })
    }

    const getCardDataItems = () => {
        let data = [...cardListData];
        if (showAdSlot) {
            data.splice(2, 0, null);
        }
        let bodySnippet: any;
        if (isCSR() && PAGEBUILDER_URLS.some(url => window.location.origin.includes(url))) {
            let resolution = `301.59 X 66`;
            if ((window as any).gpEditor && (window as any).gpEditor.getDevice() === 'Mobile portrait') {
                resolution = `343 X 122`;
            }
            bodySnippet = `<div class="add-container" style="display: flex; justify-content: center; align-items: center; width: 100%; height: 68px; background-color: #f0f0f0; padding: 0px;  max-height: 68px;"><div class="ad-box">Ad Slot<br>${resolution}</div></div>`
       
        } 
        else if (isCSR()) {

            console.log("Only CSR")
            // console.log(clientDevice.isDesktop);
            // console.log(clientDevice.isMobile);

            // if (clientDevice.isDesktop) {
            //     console.log("it is desktop for breaking news CSR");
            //     console.log("isDesktop value : " + isDesktop);
            //     console.log("isMobile value : " + isMobile);
            //     bodySnippet = `<div id="ad-container">${props.bodyAdScript?.replace(/<script[^>]*>[\s\S]*?<\/script>/, "")}</div>`;

            // }
            // else if (clientDevice.isMobile) {
            //     console.log("it is mobile for breaking news CSR");
            //     console.log("isDesktop value : " + isDesktop);
            //     console.log("isMobile value : " + isMobile);
            //     bodySnippet = `<div id="ad-container">${props.bodyAdMobileScript?.replace(/<script[^>]*>[\s\S]*?<\/script>/, "")}</div>`;

            // }
            bodySnippet = props?.data?.attributes?.adConfigurations;
        }
        else {
            console.log("Only SSR");
            // bodySnippet  = `<div></div>`;
            bodySnippet = props?.data?.attributes?.adConfigurations;
        }

        var isViewport = false;
        if (!showViewport) { imagesInViewport = 0; }
        else {
            if (typeof imagesInViewport === 'string' && imagesInViewport.toUpperCase() === "ALL") {
                imagesInViewport = data.length;
            } else if (typeof imagesInViewport === 'string' && !isNaN(parseInt(imagesInViewport))) {
                imagesInViewport = parseInt(imagesInViewport);
            } else { imagesInViewport = 0; }
        }

        let resultArr = data.map((val, index) => {
            ////console.log('data headline', data)
            if (val == null) {
                
                if (isCSR() && PAGEBUILDER_URLS.some(url => window.location.origin.includes(url))) {
                    return (<div key={index} className="mh-101 hero-layout heroLayoutTwo" dangerouslySetInnerHTML={{ __html: addDataPosition(bodySnippet, index) }}></div>);
                }else {
                    return (<div key={index} className="mh-101 hero-layout heroLayoutTwo">{insertAdSlot(index, bodySnippet, props.name)}</div>);
                }
                
                // return (<div key={index} className="mh-101 hero-layout heroLayoutTwo" dangerouslySetInnerHTML={{ __html: addDataPosition(bodySnippet, index) }}></div>);

            } else {
                if (imagesInViewport > index) { isViewport = true; }
                else { isViewport = false; }
                return (<Card2 index1={index} item={val} showTimeStamp={showTimeStamp} showAuthorName={showAuthorName} CONSTANTS={props.CONSTANTS} isViewport={isViewport} anchorLinksValue={anchorLinksValue}/>)
            }
        })

        return resultArr;
    }

    return (
        <CacheProvider value={cache}>
            <div className="headingRow">
                <h3 className="editable"><a>{title}</a></h3>
                {showViewAll && <span className="editable deskeditable"><a href={viewAllUrl} target={fetchAnchorValue(anchorLinksValue, viewAllUrl)}className="showAll">View all</a></span>}
            </div>

            <div className="clearfix">
                {cardListData?.length && getCardDataItems()}
                <div className="mobheadingRow mobeditable">
                    {showViewAll && <span className="editable "><a href={viewAllUrl} target={fetchAnchorValue(anchorLinksValue, viewAllUrl)} className="showAll">View all</a></span>}
                </div>
            </div>

        </CacheProvider>
    )
}
